import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { APIClientProvider } from "@/services/api/provider";
import AuthGuard from "@/components/auth/AuthGuard";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "./components/layout/Layout";
import ChatContainer from "./components/chat/ChatContainer";
import FileManagement from "./pages/FileManagement";
import FewShotMemory from "./pages/FewShotMemory";
import Anleitung from "./pages/Anleitung";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <APIClientProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AuthGuard>
                <Layout>
                  <Routes>
                    <Route path="/" element={<ChatContainer />} />
                    <Route path="/documents" element={<FileManagement />} />
                    <Route path="/few-shot" element={<FewShotMemory />} />
                    <Route path="/anleitung" element={<Anleitung />} />
                    {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              </AuthGuard>
            </BrowserRouter>
          </TooltipProvider>
        </APIClientProvider>
      </AuthProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
